import {DataFetcher} from '@aboutyou/data-fetcher';
import {mobileOnly, SkeletonBlock, tabletAndUp} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {StreamGenderSwitch as StreamGenderSwitchView} from '../../../features/StreamGenderSwitch/StreamGenderSwitch';
import {useStreamGenderSwitchRequest} from './utils/useStreamGenderSwitchRequest';

export const StreamGenderSwitch: React.FC<{
  className?: string;
  adjustGenderQueryParam: boolean;
}> = props => {
  return (
    <DataFetcher
      request={useStreamGenderSwitchRequest()}
      View={StyledStreamGenderSwitchView}
      Loading={() => <Skeletons />}
      viewProps={props}
      Error={null}
    />
  );
};

const StyledStreamGenderSwitchView = styled(StreamGenderSwitchView)`
  &&& {
    ${mobileOnly(css`
      border-top: unset;
    `)}
  }
`;

const Skeletons: React.FC = () => {
  return <StyledSkeletonBlock />;
};

const StyledSkeletonBlock = styled(SkeletonBlock)`
  width: 100%;
  height: 36px;
  border-radius: 0;
  margin: 4px 0 0;

  ${tabletAndUp(
    css`
      width: 30%;
      height: 24px;
      border-radius: 110px;
      margin: 0;
    `,
  )}
`;
